import React, { useState } from "react";
import styles from "./BarTopFilterDate.module.scss";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Popover } from "antd";
import Calender from "../Calender";
import arrowdown from "../../assets/icons/newicons/angle-down.svg";
// import { DatePicker } from "@mui/x-date-pickers";
import { DatePicker, Space } from "antd";
import moment from "moment";
import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

type TitleProps = {
	title?: string;
	setDateEvent: React.Dispatch<React.SetStateAction<string>>;
	dateEvent?: string;
	fromDate: any;
	toDate: any;
	calender?: any;
	currency?: any;
	setCalender?: any;
	setCurrency?: any;
	showMenu?: boolean;
	currenciesData?: any;
};

function BarTopFilterDate({
	title,
	setDateEvent,
	dateEvent,
	calender,
	setCalender,
	fromDate,
	toDate,
	currency,
	setCurrency,
	currenciesData,
	showMenu = true,
}: TitleProps) {
	const [anchoredEl, setAnchoredEl] = React.useState<null | HTMLElement>(null);
	const ITEM_HEIGHT = 48;
	const opened = Boolean(anchoredEl);

	const handledClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchoredEl(event.currentTarget);
	};

	const handledClose = () => {
		setAnchoredEl(null);
	};

	const options = ["Export to CSV", "Export to XLS", "Export to JPEG"];

	// const clickHandler = (option: string) => {
	//   handledClose();
	// };

	// const handleClick = (event: any) => {
	//   // console.log(event.currentTarget.getAttribute("data-value"));

	// };

	const handleDateFilter = (event: any) => {
		setDateEvent(event.currentTarget.value);
	};

	const convertedDate = (dateData: any[] = []) => {
		const data = dateData?.map((dat) => {
			let date;
			date = moment(dat.$d).format("YYYY-MM-DD");
			return date;
		});

		return data;
	};

	const dateFormat = "YYYY/MM/DD";

	const onChangeHandler = (val: any) => {
		const ret = convertedDate(val);
		setCalender(ret);
		setDateEvent("custom");
	};

	const disabledDate: RangePickerProps["disabledDate"] = (current) => {
		// Can not select days before today and today
		return current && current > dayjs().endOf("day");
	};

	const onChangeCurrency = (event: any) => {
		setCurrency(event.currentTarget.value);
	};

	return (
		<>
			<div className={styles.filterWrapper}>
				<div className={styles.selectWrapper}>
					<select onChange={handleDateFilter} value={dateEvent}>
						<option value="today">Today</option>
						<option value="last7days">Last 7 days</option>
						<option value="last30days">Last Month</option>
						<option value="lastyear">This year</option>
						<option value="custom">Custom</option>
					</select>
				</div>
				<div className={styles.dateWrapper}>
					<div className={styles.datepickerContainer}>
						<RangePicker
							onChange={(val) => {
								onChangeHandler(val);
							}}
							disabledDate={disabledDate}
							bordered={false}
							style={{
								borderRadius: "10px",
								fontFamily: "Avenir",
								fontStyle: "normal",
								fontWeight: 500,
								fontSize: "14px",
								lineHeight: "32px",
								letterSpacing: " 0.00321686px",
								color: "#4F4F4F",
							}}
						/>
					</div>

					{currenciesData && currenciesData.length > 0 ? (
						<div className={styles.selectWrapper}>
							<select value={currency} onChange={onChangeCurrency}>
								{currenciesData.map((curr: string, i: number) => (
									<option key={i} value={curr}>
										{curr}
									</option>
								))}
							</select>
						</div>
					) : null}
				</div>
			</div>
		</>
	);
}

export default BarTopFilterDate;
